import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';


export default function BookingScreen() {
    const [countryList, setCountryList] = useState([]);
    const [country, setCountry] = useState('');
    const [cityList, setCityList] = useState([]);
    const [city, setCity] = useState('');
    const [data, setData] = useState({});
    const adminSignin = useSelector((state) => state.adminSignin);
    const { adminInfo } = adminSignin;

    const navigate = useNavigate();

    console.log("data:", data);
    const updateData = (key, value) => {
        setData((prevData) => ({
            ...prevData,
            [key]: value,
        }));
    };

    const addAll = () => {
        if (country) {
            updateData('city_list', 'All');
        }
    };

    const addCity = () => {
        if (city && !data.city_list?.includes(city)) {
            if (data.city_list === 'All') {
                updateData('city_list', [city]);
            } else {
                const updatedCityList = [...(data.city_list || []),  city];
                updateData('city_list', updatedCityList);
            }
        }
    };

    const removeCity = (cityToRemove) => {
        const updatedCityList = (data.city_list || []).filter((c) => c !== cityToRemove);
        console.log("Updated City List:", updatedCityList);
        updateData('city_list', updatedCityList);
    };

    const updateOptrip = async () => {
        try {
            const response = await axios.post('/api/admin/optrip/update', data, {
                headers: {
                    Authorization: `Bearer ${adminInfo.token}`,
                },
            });
            if (response.status !== 200) {
                console.error('Error updating data:', response);
            }
            console.log('Data updated successfully:', response.data);
            alert('Data updated successfully');
            //  reset the form or show a success message here
            setData({});
            setCountry('');
            setCity('');
            setCityList([]);
        } catch (error) {
            console.error('Error updating data:', error);
        }
    };

    const scrapeNow = async () => {
        try {
            const response = await axios.get('https://optrip.workingfromhammock.com/scrape/booking?country=' + country);
            if (response.status !== 200) {
                console.error('Error scraping data:', response);
                alert('Error scraping data');
                return;
            }
            console.log('Scraping started successfully:', response.data);
            alert('Scraping started successfully');
            // Optionally, you can update the status or other fields after scraping
        } catch (error) {
            console.error('Error scraping data:', error);
            alert('Error scraping data');
        }
    };

    const resetScrapping = () => {
        updateData('status', 'None');
        updateData('scrapped', 0);
        updateData('booking_completed', 0);
    }

    useEffect(() => {
        const fetchCountry = async () => {
            try {
                const response = await axios.get('/api/admin/optrip/country', {
                    headers: {
                        Authorization: `Bearer ${adminInfo.token}`,
                    },
                });
                if (response.status !== 200) {
                    throw new Error('Failed to fetch countries');
                }
                setCountryList(response.data);
            } catch (error) {
                console.error('Error fetching countries:', error);
            }
        };
        fetchCountry();
    }, [adminInfo.token]);

    useEffect(() => {
        const fetchCity = async () => {
            try {
                const response = await axios.get(`/api/admin/optrip/city/${country}`, {
                    headers: {
                        Authorization: `Bearer ${adminInfo.token}`,
                    },
                });
                if (response.status !== 200) {
                    throw new Error('Failed to fetch cities');
                }
                setCityList(response.data);
                setCity(''); // Reset city selection when country changes
            } catch (error) {
                console.error('Error fetching cities:', error);
            }
        };

        // Fetch data only if a country is selected
        const fetchData = async () => {
            try {
                const response = await axios.get(`/api/admin/optrip/status/${country}`, {
                    headers: {
                        Authorization: `Bearer ${adminInfo.token}`,
                    },
                });
                if (response.status !== 200) {
                    throw new Error('Failed to fetch data');
                }
                if (!response.data || response.data.length === 0) {
                    updateData('country', country);
                    updateData('country_code', countryList.find(c => c.country === country)?.country_code.toLowerCase() || '');
                    updateData('city_list', []);
                    updateData('status', 'None');
                    updateData('booking_stays_total', 0);
                    updateData('booking_completed', 0);
                    updateData('scrapped', 0);
                    return;
                }
                setData(response.data || {});
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        if (country) {
            fetchCity();
            fetchData();
        } else {
            setCityList([]);
        }
    }, [country, adminInfo.token]);

    useEffect(() => {
        if (!adminInfo) {
            navigate("/signin");
        }
    }, [adminInfo, navigate]);

  return (
    <>
    <div className='table-container'>
        <h1>Booking Scrapper</h1>
        <table className='table mt-10'>
            <thead>
                <tr>
                    <th> Properties </th> 
                    <td className='col-md-9'> Values </td>
                    {/* <th> Status  </th>*/}
                    <td> Action </td> 
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>Country</th>
                    <td className='col-md-9'> 
                        <select id="countrySelect" value={country} onChange={(e) => {setCountry( e.target.value); }} >
                            <option value="" disabled> Select a country </option>
                            {countryList && countryList.map((country, index) => (
                            <option key={index} value={country.country}>{country.country}</option>
                            ))}
                        </select> 
                    </td>
                </tr>
                <tr>
                    <th>Add a City</th>
                    <td className='col-md-9'>
                        <select id="citySelect" value={city} onChange={(e) => {setCity( e.target.value); }} >
                            <option value="" disabled> Select a city </option>
                            {cityList && cityList.map((city, index) => (
                                <option key={index} value={city}>{city}</option>
                                ))}
                            </select>
                            
                       
                    </td>
                    <td>
                        <button className='primary' onClick={addAll}> All </button>
                        <button className='primary' onClick={addCity}> Add </button>
                        <button className='secondry' onClick={() => removeCity(city)}> Remove </button>
                    </td>
                </tr>
                <tr>
                    <th>Selected cities</th>
                    <td className='col-md-9'>
                        <div>
                            <textarea defaultValue={"No City Selected"} value={data?.city_list} className='city-list' />

                            {/* </input> */}
                            
                            
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>Status</th>
                    <td>
                        <select value={data?.status} onChange={(e) => updateData('status', e.target.value)}>
                            <option value="None">None</option>
                            <option value="In Progress">In Progress</option>
                            <option value="Completed">Completed</option>
                            <option value="Paused">Paused</option>
                            <option value="Error">Error</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>Total Stays</th>
                    <td>{data?.booking_stays_total}</td>
                </tr>
                <tr>
                    <th>Total Visited</th>
                    <td>{data?.booking_completed}</td>
                </tr>
                <tr>
                    <th>Total Scrapped</th>
                    <td>{data?.scrapped}</td>
                    <td><button className='primary' onClick={resetScrapping}>Reset</button></td>
                </tr>
                <tr>
                    <th></th>
                    <td><button className='primary' onClick={() => {updateOptrip()}}>Register/Update</button></td>
                    <td><button className='ATC' onClick={() => {scrapeNow()}}>Scrape now</button></td>
                </tr>
            </tbody>
        </table>
    </div>
    </>
  );
}